import { render, staticRenderFns } from "./briefcase-activity-log.html?vue&type=template&id=8f835634&scoped=true&external"
import script from "./briefcase-activity-log.js?vue&type=script&lang=js&external"
export * from "./briefcase-activity-log.js?vue&type=script&lang=js&external"
import style0 from "./briefcase-activity-log.scss?vue&type=style&index=0&id=8f835634&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f835634",
  null
  
)

export default component.exports